import React, {Component} from 'react';
import './App.css';
import {Redirect, Route, Switch} from 'react-router'
import {BrowserRouter} from 'react-router-dom'
import SestRazst from "./SestRazst";
import Precrkuj from "./Precrkuj";
import Settings from "../settings/Settings";

export default class App extends Component {

    constructor() {
        super();
        if (Settings.load("pre_lang") === null) {
            Settings.save("pre_lang", 1);
        }
        if (Settings.load("lang") === null) {
            Settings.save("lang", "slv")
        }
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route path="/p" component={Precrkuj}/>
                    <Route path="/s" component={SestRazst}/>
                    <Redirect to="/s"/>
                </Switch>
            </BrowserRouter>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/main/App.js